import { Tab as HeroUiTab } from '@heroui/tabs';

export const Tab = HeroUiTab;
